import React, { Component } from "react";
import Row from "react-bootstrap/Row";
import Modal from "react-awesome-modal";
import "bootstrap/dist/css/bootstrap.min.css";
import styles from "./Home.module.scss";
import FloatComponents from "components/FloatComponents/FloatComponents";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import SideBar from "./SideBar/SideBar";
import MapContainer from "components/MapContainer/MapContainer";
import BoxFilterResponsive from "components/BoxFilter/BoxFilterResponsive";
//import UI_PHASES from "SidebarPhases.js";

export class Home extends Component {
    openModal() {
        this.setState({
            visible: true
        });
    }

    closeModal() {
        this.setState({
            visible: false
        });
    }

    constructor(props) {
        super(props);
        this.state = {
            sidebarOpen: false,
            selectedMkr: null,
            zoom: 14,
            isSeenOnMap: false,
            // uiPhase: UI_PHASES.HOME_MAIN
        };
        // this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this);
    }

    componentDidUpdate(prevprops, prevstate) {
        if (prevstate.zoom !== this.state.zoom) {
            // console.log(`Updated was ${prevstate.zoom} is ${this.state.zoom}`);
        }
    }

    setIsSeenOnMap = val => {
        this.setState({ isSeenOnMap: val });
    };

    onSetSidebarOpen(open) {
        // this.setState({ sidebarOpen: open });
    }

    setSelectedMkr = val => {
        this.setState({ selectedMkr: val });
        // this.setUiPhase(UI_PHASES.HOME_EXPANDED);
    };

    setModal = val => {
        this.setState({ selectedMkr: val });
        // this.setUiPhase(UI_PHASES.HOME_EXPANDED);
        this.openModal({ selectedMkr: val });
    };
    setZoom = zoom => {
        const zoomValue = zoom;
        this.setState({ zoom: null }, () => this.setState({ zoom: zoomValue }));
    };

    setUiPhase = phase => {
        this.setState({ uiPhase: phase });
    };

    setSelectedEstabelecimento = item => {
        this.setState({ selectedEstabelecimento: item });
    };

    render() {
        return (
            <div className="Login-header">
                <Row className={styles.home}>
                    <div className={styles.sideBar}>
                        <SideBar
                            filtrar={this.props.filtrar}
                            setUiPhase={this.setUiPhase}
                            setSelectedMkr={this.setSelectedMkr}
                            selectedMkr={this.state.selectedMkr}
                            favoritar={this.props.favoritar}
                            estabelecimentosFavoritos={
                                this.props.estabelecimentosFavoritos
                            }
                            estabelecimentos={this.props.estabelecimentos}
                            // expanded={this.state.uiPhase === UI_PHASES.HOME_EXPANDED}
                            userLocation={this.props.userLocation}
                            setSelectedEstabelecimento={this.setSelectedEstabelecimento.bind(
                                this
                            )}
                            categorias={this.props.categorias}
                            setZoom={this.setZoom}
                            setIsSeenOnMap={this.setIsSeenOnMap}
                            setFilterText={this.props.setFilterText}
                            filterText={this.props.filterText}
                        />
                    </div>
                    <div className={styles.map}>
                        <MapContainer
                            onMapMove={this.props.onMapMove}
                            filtrar={this.props.filtrar}
                            estabelecimentos={this.props.estabelecimentos}
                            setSelectedMkr={this.setSelectedMkr}
                            setModal={this.setModal}
                            favoritar={this.props.favoritar}
                            estabelecimentosFavoritos={
                                this.props.estabelecimentosFavoritos
                            }
                            maxDistance={10000}
                            userLocation={this.props.userLocation}
                            mapCenter={this.props.mapCenter}
                            setUserLocation={this.props.setUserLocation}
                            selectedEstabelecimento={
                                this.state.selectedEstabelecimento
                            }
                            categorias={this.props.categorias}
                            setSelectedEstabelecimento={this.setSelectedEstabelecimento.bind(
                                this
                            )}
                            setZoom={this.setZoom}
                            zoom={this.state.zoom}
                            isSeenOnMap={this.state.isSeenOnMap}
                            setIsSeenOnMap={this.setIsSeenOnMap}
                        />
                        <FloatComponents
                            filtrar={this.props.filtrar}
                            selectedMkr={this.state.selectedMkr}
                            setSelectedMkr={this.setSelectedMkr}
                            estabelecimentosFavoritos={
                                this.props.estabelecimentosFavoritos
                            }
                            favoritar={this.props.favoritar}
                            estabelecimentos={this.props.estabelecimentos}
                            userLocation={this.props.userLocation}
                            mapCenter={this.props.mapCenter}
                            setSelectedEstabelecimento={this.setSelectedEstabelecimento.bind(
                                this
                            )}
                            categorias={this.props.categorias}
                            setZoom={this.setZoom}
                            setFilterText={this.props.setFilterText}
                            filterText={this.props.filterText}
                            isSeenOnMap={this.state.isSeenOnMap}
                            setIsSeenOnMap={this.setIsSeenOnMap}
                        />
                        <div className={styles.modal}>
                            <Modal
                                visible={this.state.visible}
                                width="370px"
                                height="290px"
                                effect="fadeInUp"
                                onClickAway={() => this.closeModal()}
                            >
                                <BoxFilterResponsive
                                    filtrar={this.props.filtrar}
                                    selectedMkr={this.state.selectedMkr}
                                    favoritar={this.props.favoritar}
                                    estabelecimentosFavoritos={
                                        this.props.estabelecimentosFavoritos
                                    }
                                    userLocation={this.props.userLocation}
                                    mapCenter={this.props.mapCenter}
                                    setSelectedEstabelecimento={this.setSelectedEstabelecimento.bind(
                                        this
                                    )}
                                    categorias={this.props.categorias}
                                    setZoom={this.setZoom}
                                    setFilterText={this.props.setFilterText}
                                    filterText={this.props.filterText}
                                    isSeenOnMap={this.state.isSeenOnMap}
                                />
                                <p
                                    onClick={() => this.closeModal()}
                                    className={styles.close}
                                >
                                    Fechar
                                </p>
                            </Modal>
                        </div>
                    </div>
                </Row>
            </div>
        );
    }
}

export default Home;
